export const FUNNELS = {
  signupPurchase: 'signup_purchase',
  quizResults: 'quiz_results_to_signup',
  reactivation: 'reactivation_flow',
} as const;

export const FUNNEL_VERSIONS = {
  signupPurchase: '2026-06-02',
  quizResults: '2026-06-02',
  reactivation: '2026-08-18',
} as const;
